import { render, staticRenderFns } from "./LeadSentence.vue?vue&type=template&id=7da8b0d3&scoped=true&"
import script from "./LeadSentence.vue?vue&type=script&lang=js&"
export * from "./LeadSentence.vue?vue&type=script&lang=js&"
import style0 from "./LeadSentence.vue?vue&type=style&index=0&id=7da8b0d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7da8b0d3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VSimpleTable,VSpacer,VTextarea})
